import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game-history" }
const _hoisted_2 = { class: "text-gray-300 text-left" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "left-col" }
const _hoisted_5 = { class: "right-col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "left-col font-mono text-xl" }, "Rounds", -1)
const _hoisted_9 = { class: "right-col font-mono text-xl" }
const _hoisted_10 = { class: "left-col font-mono" }
const _hoisted_11 = { class: "right-col font-mono" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.game.name) + " History", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.players, (player) => {
      return (_openBlock(), _createElementBlock("article", {
        class: "card bg-gray-300 my-8",
        key: player.id
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(player.name), 1),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(player.score), 1)
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(player.rounds.length), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedRounds(player.rounds), (round) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex",
            key: round.time
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.fromNow(round.time)), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(round.score >= 0 ? '+' : '') + _toDisplayString(round.score), 1)
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}